/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tasks: [],
  count: 0,
};

const taskSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    /**
     *
     * @param {*} state
     * @param {{payload:{tasks:any[],count:number}}} action
     */
    setTasks(state, action) {
      state.tasks = action.payload.tasks;
      state.count = action.payload.count;
    },
    updateLeadTaskRedux(state, action) {
      const index = state.tasks.findIndex(task => +task.id === +action.payload.id);
      if (index !== -1) {
        state.tasks[index] = action.payload;
      }
    },
    addTask(state, action) {
      state.tasks.push(action.payload);
      state.count++;
    },
    deleteTask(state, action) {
      const index = state.tasks.findIndex(task => +task.id === +action.payload);
      if (index !== -1) {
        state.tasks.splice(index, 1);
      }
    },
    reopenTask(state, action) {
      const index = state.tasks.findIndex(task => +task.id === +action.payload);
      if (index !== -1) {
        state.tasks[index] = {
          ...state.tasks[index],
          taskStatus: "CREATED",
        };
      }
    },
  },
});

export const { setTasks, updateLeadTaskRedux, addTask, deleteTask, reopenTask } = taskSlice.actions;

export default taskSlice.reducer;
